import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body has-text-centered" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 1,
  class: "subtitle"
}

import { computed, ref, toRefs, watch } from "vue";
import xlsx, { WorkBook } from "xlsx";

type TFileUnion = WorkBook | null | File;

const __default__ = {
  name: "ExcelAndCsvFileUpload",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    file: null
  },
  emits: ["update:file"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:file", val: TFileUnion): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  file: TFileUnion;
}




const { file } = toRefs(props);

const processedFile = computed({
  get() {
    return file.value;
  },
  set(val: TFileUnion) {
    emit("update:file", val);
  },
});

const dropFile = ref(file.value as File);
const fileName = ref("");

watch(dropFile, (newVal) => {
  if (newVal !== null) {
    fileName.value = newVal.name;
    let reader = new FileReader();
    reader.onload = async function () {
      const target = await newVal.arrayBuffer();
      let data = new Uint8Array(target);
      let workbook = xlsx.read(data, {
        type: "array",
        cellDates: true,
        cellStyles: true,
      });

      processedFile.value = workbook;
    };
    reader.readAsArrayBuffer(newVal);
  } else {
    processedFile.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_upload = _resolveComponent("o-upload")!

  return (_openBlock(), _createBlock(_component_o_upload, {
    class: "column is-full",
    modelValue: dropFile.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropFile).value = $event)),
    "drag-drop": "",
    expanded: "",
    native: "",
    accept: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_o_icon, {
              icon: "upload",
              size: "is-large"
            }),
            (dropFile.value === null)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_4, " Drop your files here or click to upload "))
              : _createCommentVNode("", true),
            (dropFile.value !== null)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(fileName.value), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})